export default class CompanyCommonWords {
  constructor($scope, UserService) {
    $scope.common_words = window.common_words;

    $scope.add_common_word = function() {
      $scope.adding = true;
      $scope.add_error = '';
      var common_word = {
        id: null,
        word: $scope.common_word
      };
      UserService.save_company_common_word(common_word).then(function(data) {
        if (data.success) {
          $scope.add_error = 'Word added!';
          $scope.push_word(data.id, common_word.word);
        } else {
          $scope.add_error = data.message;
        }
        $scope.adding = false;
      });
    };

    $scope.push_word = function(id, word) {
      var common_word = {
        company_common_word: {
          id: id,
          word: word
        }
      };
      $scope.common_words.push(common_word);
    };
  }
}

CompanyCommonWords.$inject = ['$scope', 'UserService'];



// WEBPACK FOOTER //
// ./front/js/admin/controllers/company-common-words.ctrl.js